module.exports = __webpack_public_path__ + "/bundle/asset/U1_06-4018cf0b002920272bbea48aa7e1849c.gif";